module.exports = __webpack_public_path__ + "static/media/IMG_0062.55946a26.jpg";